<template lang="pug">
  .width-100.m-bottom-3(v-if='showContent')
    subtopic-banner.m-top-3(v-if='subtopicView')
    section.section.column.width-100(v-if='!isCustom && showEphemeride && (currentEphemeride.totalCount || currentEphemeride.loading)')
      h2.title-medium.m-bottom-1 {{ $t("feed.searchResults.sections.currentEphemeride") }}
      .grid.grid-columns-3.gap-20(v-if='currentEphemeride.totalCount')
        ephemeride-card(
          v-for='folder in currentEphemeride.data'
          :key='folder.id'
          :id='folder.id'
          :image='folder.feedThumbnail'
          :name='folder.title'
          :startDate='folder.startDate'
          :folderLocale='folder.selectedLocale'
        )
      .grid.gap-20.grid-columns-3.relative.width-100(
        v-if='currentEphemeride.loading'
        :class='{"m-top-2": currentEphemeride.totalCount}'
      )
        sk-ephemeride-card(v-for='n in 3' :key='n')
        loader.absolute(size="inner")
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='currentEphemeride.page + 1 < currentEphemeride.totalPages'
        @click='loadMore("currentEphemeride", 3)'
      ) {{ $t("feed.searchResults.seeMore") }}
    section.section.column.width-100(v-if='showSubtopics && (subtopics.totalCount || subtopics.loading)')
      h2.title-medium.m-bottom-1 {{ $t("feed.searchResults.sections.subtopics") }}
      .grid.grid-columns-4.gap-20(v-if='subtopics.totalCount')
        topic-card.topic(
          v-for='subtopic in subtopics.data'
          :key='subtopic.id'
          :topic='subtopic'
          isSubtopic
        )
      .grid.gap-20.grid-columns-4.relative.width-100(
        v-if='subtopics.loading'
        :class='{"m-top-2": subtopics.totalCount}'
      )
        sk-topic-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='subtopics.page + 1 < subtopics.totalPages'
        @click='loadMore("subtopics", 4)'
      ) {{ $t("feed.searchResults.seeMore") }}
    section.section.column.width-100(v-if='!isCustom && !hideContent && (folders.totalCount || folders.loading)')
      h2.title-medium.m-bottom-1 {{ $t("feed.searchResults.sections.folders") }}
      .grid.grid-columns-4.gap-20(v-if='folders.totalCount')
        kimple-folder-feed.m-bottom-2(
          v-for='folder in folders.data'
          :key='folder.id' noMargin
          :folder='folder'
          @copyFolder='copyFolder'
          origin='Search results'
        )
      .grid.gap-20.grid-columns-4.relative.width-100(
        v-if='folders.loading'
        :class='{"m-top-2": folders.totalCount}'
      )
        sk-folder-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='folders.page + 1 < folders.totalPages'
        @click='loadMore("folders", 4)'
      ) {{ $t("feed.searchResults.seeMore") }}
    section.section.column.width-100(v-if='!hideContent && (programs.totalCount || programs.loading)')
      h2.title-medium.m-bottom-1 {{ $t("feed.searchResults.sections.programs") }}
      .grid.grid-columns-4.gap-20(v-if='programs.totalCount')
        educational-program-card.m-bottom-2(
          v-for='program in programs.data'
          :key='program.id' noMargin
          :program='program'
        )
      .grid.gap-20.grid-columns-4.relative.width-100(
        v-if='programs.loading'
        :class='{"m-top-2": programs.totalCount}'
      )
        sk-educational-program-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='programs.page + 1 < programs.totalPages'
        @click='loadMore("programs", 4)'
      ) {{ $t("feed.searchResults.seeMore") }}
    section.section.column.width-100(v-if='!hideContent && (resources.totalCount || resources.loading)')
      h2.title-medium.m-bottom-1 {{ $t("feed.searchResults.sections.resources") }}
      .grid.grid-columns-4.gap-20(v-if='resources.totalCount')
        resource-card.m-bottom-2(
          v-for='resource in resources.data'
          :key='resource.id'
          :resource='resource' noMargin
          :bookmarked='resource.isInAnyFolder'
        )
      .grid.gap-20.grid-columns-4.relative.width-100(
        v-if='resources.loading'
        :class='{"m-top-2": resources.totalCount}'
      )
        sk-resource-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='resources.page + 1 < resources.totalPages'
        @click='loadMore("resources", 4)'
      ) {{ $t("feed.searchResults.seeMore") }}
  empty-results(v-else)
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ResourceCard from '../ResourceCard'
import EducationalProgramCard from '@/components/EducationalProgramCard'
import KimpleFolderFeed from '@/components/KimpleFolderFeed'
import Loader from '../Loader'
import debounce from 'lodash.debounce'
import SkResourceCard from '@/components/SkResourceCard'
import SkEducationalProgramCard from '@/components/SkEducationalProgramCard'
import SkFolderCard from '@/components/SkFolderCard'
import SkEphemerideCard from '../SkEphemerideCard'
import EphemerideCard from '../EphemerideCard'
import TopicCard from '../TopicCard'
import SkTopicCard from '../SkTopicCard'
import SubtopicBanner from './Banners/SubtopicBanner'
import userRole from '../../mixins/userRole'
import EmptyResults from './EmptyResults'

export default {
  mixins: [userRole],
  components: {
    EmptyResults,
    SubtopicBanner,
    TopicCard,
    SkTopicCard,
    SkEphemerideCard,
    SkResourceCard,
    SkFolderCard,
    SkEducationalProgramCard,
    Loader,
    EphemerideCard,
    ResourceCard,
    EducationalProgramCard,
    KimpleFolderFeed
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale,
      resources: state => state.newFeed.searchResults.resources,
      programs: state => state.newFeed.searchResults.programs,
      folders: state => state.newFeed.searchResults.folders,
      subtopics: state => state.newFeed.searchResults.subtopics,
      currentEphemeride: state => state.newFeed.searchResults.currentEphemeride,
      results: state => state.newFeed.searchResults
    }),
    loadingResults() {
      return (
        this.resources.loading ||
        this.programs.loading ||
        this.folders.loading ||
        this.subtopics.loading ||
        this.currentEphemeride.loading
      )
    },
    emptyResults() {
      return (
        this.resources.totalCount === 0 &&
        this.programs.totalCount === 0 &&
        this.folders.totalCount === 0 &&
        this.subtopics.totalCount === 0 &&
        this.currentEphemeride.totalCount === 0
      )
    },
    showContent() {
      return (
        (this.showSubtopics && (this.subtopics.totalCount || this.subtopics.loading)) ||
        (!this.hideContent && (this.folders.totalCount || this.folders.loading)) ||
        (!this.hideContent && (this.programs.totalCount || this.programs.loading)) ||
        (!this.hideContent && (this.resources.totalCount || this.resources.loading)) ||
        (this.showEphemeride && (this.currentEphemeride.totalCount || this.currentEphemeride.loading))
      )
    },
    showSubtopics() {
      return this.$route.query.topicIds && !this.subtopicView
    },
    showEphemeride() {
      return this.$route.query.months
    },
    hideContent() {
      return Object.keys(this.$route.query).includes('months') && Object.keys(this.$route.query).length === 1
    },
    subtopicView() {
      return this.$route.query.subtopicIds
    },
    selectedFilters() {
      return this.$route.query
    },
    hasFilters() {
      return Object.keys(this.selectedFilters).length
    }
  },
  async created() {
    await this.hydrateCategories()
    if (this.hasFilters) this.search()
  },
  watch: {
    selectedFilters() {
      this.clearSearchResultsContent()
      this.search()
    },
    locale() {
      this.clearSearchResultsContent()
      this.search()
    }
  },
  beforeDestroy() {
    this.clearSearchResults()
  },
  methods: {
    ...mapActions([
      'hydrateCategories',
      'searchResults',
      'clearSearchResults',
      'clearSearchResultsContent'
    ]),
    copyFolder(success) {
      this.$emit('copyFolder', success)
    },
    search: debounce(function() {
      this.showSubtopics && this.searchResultsFor('subtopics', 4)
      !this.isCustom && this.searchResultsFor('folders', 4)
      this.searchResultsFor('programs', 4)
      this.searchResultsFor('resources', 4)
      !this.isCustom && this.showEphemeride && this.searchResultsFor('currentEphemeride', 3)
    }, 1500),
    loadMore(type, pageSize) {
      this.searchResults({
        type,
        pageSize,
        pageNumber: this[type].page + 1,
        filters: this.$route.query
      })
    },
    async searchResultsFor(type, pageSize) {
      await this.searchResults({
        type,
        pageSize,
        pageNumber: 0,
        firstLoading: true,
        customLicense: this.isCustom,
        filters: this.$route.query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.section{
  padding: 25px 0;
}
</style>
